export const ROOT_DOM_ID = 'root';
